import React, { useState } from 'react';
import CalcShell from '../CalcShell';
import { CNetRow, CNetActions, CNetResult, CNetHintBar, G } from '../other/_cnet';

export default function PercentErrorCalc() {
  const [observed, setObserved] = useState(10);
  const [trueVal, setTrueVal] = useState(11);
  const [res, setRes] = useState(null);
  const calc = () => {
    const o = Number(observed), t = Number(trueVal);
    if (t === 0) { setRes({ error: 'True value cannot be 0' }); return; }
    const diff = o - t;
    const err = (diff / t) * 100;
    setRes({ o, t, diff, err, absErr: Math.abs(err) });
  };
  const clear = () => { setObserved(10); setTrueVal(11); setRes(null); };
  return (
    <CalcShell showActions={false} look="cnet" title="Percent Error Calculator" subtitle="Compare an observed value to the true (theoretical) value.">
      <CNetHintBar />
      <div className="cnet-panel">
        <CNetRow label="Observed Value">
          <input data-testid="pe-observed" className="cnet-input" type="number" step="0.0001" value={observed} onChange={e => setObserved(e.target.value)} />
          <span />
        </CNetRow>
        <CNetRow label="True Value">
          <input data-testid="pe-true" className="cnet-input" type="number" step="0.0001" value={trueVal} onChange={e => setTrueVal(e.target.value)} />
          <span />
        </CNetRow>
        <CNetActions onCalc={calc} onClear={clear} testId="pe" />
      </div>
      {res && !res.error && (
        <CNetResult>
          <div className="text-2xl font-semibold text-slate-900" data-testid="pe-result">
            Percent Error = <span className="text-[#4c7b25]">{G(res.err, 4)}%</span>
            <span className="text-slate-700 text-lg ml-2">(absolute: {G(res.absErr, 4)}%)</span>
          </div>
          <div className="mt-3 font-bold text-slate-900">Steps:</div>
          <div className="ml-2 text-slate-800 leading-7 font-mono text-sm" data-testid="pe-steps">
            <div>Percent Error = ((Observed − True) / True) × 100%</div>
            <div className="ml-4">= (({res.o} − {res.t}) / {res.t}) × 100%</div>
            <div className="ml-4">= ({G(res.diff, 4)} / {res.t}) × 100%</div>
            <div className="ml-4">= <b className="text-[#4c7b25]">{G(res.err, 4)}%</b></div>
          </div>
          <table className="data-table mt-3" data-testid="pe-table">
            <tbody>
              <tr><td>Absolute error</td><td>{G(res.diff, 4)}</td></tr>
              <tr><td>Relative error</td><td>{G(res.err / 100, 6)}</td></tr>
              <tr><td>Absolute percent error</td><td className="font-semibold">{G(res.absErr, 4)}%</td></tr>
            </tbody>
          </table>
        </CNetResult>
      )}
      {res && res.error && <div className="text-red-600 mt-3">{res.error}</div>}
    </CalcShell>
  );
}
